/**
 * PLC / Factory device command password persisted after login (localStorage).
 * Used when sending start/stop/maintenance/active and chat control payloads.
 */
export const DEVICE_COMMAND_PASSWORD_KEY = 'admin_device_command_password';

/** Same key as AuthContext TOKEN_ORG_KEY — org for login refresh on WebSocket control. */
export const LOGIN_ORG_NAME_KEY = 'admin_org_name';

export const LOGIN_USERNAME_KEY = 'admin_login_username';

export function getStoredLoginUsername(): string {
  try {
    return (localStorage.getItem(LOGIN_USERNAME_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function setStoredLoginUsername(username: string): void {
  try {
    const u = (username || '').trim();
    if (u) {
      localStorage.setItem(LOGIN_USERNAME_KEY, u);
    } else {
      localStorage.removeItem(LOGIN_USERNAME_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function clearStoredLoginUsername(): void {
  try {
    localStorage.removeItem(LOGIN_USERNAME_KEY);
  } catch {
    /* ignore */
  }
}

/** Organization name saved at login (shared with AuthContext). */
export function getStoredLoginOrgName(): string {
  try {
    return (localStorage.getItem(LOGIN_ORG_NAME_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function getStoredDeviceCommandPassword(): string {
  try {
    return (localStorage.getItem(DEVICE_COMMAND_PASSWORD_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function setStoredDeviceCommandPassword(password: string): void {
  try {
    const p = (password || '').trim();
    if (p) {
      localStorage.setItem(DEVICE_COMMAND_PASSWORD_KEY, p);
    } else {
      localStorage.removeItem(DEVICE_COMMAND_PASSWORD_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearStoredDeviceCommandPassword(): void {
  try {
    localStorage.removeItem(DEVICE_COMMAND_PASSWORD_KEY);
  } catch {
    /* ignore */
  }
}

export function clearStoredControlCredentials(): void {
  clearStoredDeviceCommandPassword();
  clearStoredLoginUsername();
}
